import { getEnv } from '@js/utils-feeds';

const accessMaps = {
  middleAccess: {
    production: '//content.cc.heytapmobi.com/',
    test: '//gank.search-test.wanyol.com/',
  },
  commentAccess: {
    production: '//comment.cpc.heytapmobi.com/',
    test: '//comment-test-cpc.wanyol.com/',
    dev: '//comment.dev-browser.wanyol.com/',
    development: '//comment.dev-browser.wanyol.com/',
  },
  feedsAccess: {
    production: '//iflow.browser.heytapmobi.com/',
    test: '//i-test-cpc.wanyol.com/',
    dev: '//i.dev.browserproxy.wanyol.com/',
    development: '//i.dev.browserproxy.wanyol.com/',
  },
  baseUri: {
    production: '//news.heytapdownload.com/',
    test: '//news-test-cpc.wanyol.com/',
    dev: '//opponews.dev.browserproxy.wanyol.com/',
    development: '//opponews.browser.local.me/',
  },
  likeAccess: {
    production: '//like.cpc.heytapmobi.com/',
    test: '//like-test-cpc.wanyol.com/',
    dev: '//like-test-cpc.wanyol.com/',
    development: '//like-test-cpc.wanyol.com/',
  },
  gameSubscriptionAccess: {
    production: '//i.browser.heytapmobi.com/',
    test: '//i-test-browser-cpc.wanyol.com/',
    dev: '//i.dev.browserproxy.wanyol.com/',
    development: '//i.dev.browserproxy.wanyol.com/',
  },
  relatedSearcAccess: {
    // https://bs.sc.heytapmobi.com/search/browser/relsearch
    production: '//bs.sc.heytapmobi.com/',
    test: '//i-test-browser-cpc.wanyol.com/',
    dev: '//i-dev-browser-cpc.wanyol.com/',
    development: '//i-test-browser-cpc.wanyol.com/',
  },
  dislikeAccess: {
    production: '//bs.sc.heytapmobi.com/',
    test: '//i-test-browser-cpc.wanyol.com/',
    dev: '//i-dev-browser-cpc.wanyol.com/',
    development: '//i-test-browser-cpc.wanyol.com/',
  },
  eventCardAccess: {
    production: '//ibrowser.feeds.heytapmobi.com/',
    test: '//i-test-browser-cpc.wanyol.com/',
    dev: '//i-dev-browser-cpc.wanyol.com/',
    development: '//i-test-browser-cpc.wanyol.com/',
  },
};

export function getAccessByType(type) {
  const API = window.pageData.API || {};
  if (API[type]) return API[type];
  return accessMaps[type][getEnv()] || '/';
}
